// import React from "react";

// const CancellationPolicy = () => {
//   const policies = [
//     {
//       icon: "❌",
//       condition: "Cancellations made 15 days or more before the event:",
//       detail: "👉 Eligible for a 50% refund of the booking amount.",
//     },
//     {
//       icon: "❌",
//       condition: "Cancellations made less than 7 days before the event:",
//       detail: "👉 No refund will be provided.",
//     },
//     {
//       icon: "🔄",
//       condition: "Transfer of seat:",
//       detail:
//         "If you're unable to attend, you may transfer your seat to a friend or family member. Kindly inform us at least 48 hours before the event.",
//     },
//     {
//       icon: "💼",
//       condition: "Event cancellation by organizers:",
//       detail:
//         "In the unlikely case of cancellation due to weather, safety, government-imposed bans, public protests or other unforeseen circumstances, a full refund or rescheduling option will be provided.",
//     },
//   ];

//   return (
//     <div className="space-y-6 text-gray-800">
//       <div>
//         <h2 className="text-xl font-semibold mb-2 text-blue-600">
//           📅 Cancellation Policy
//         </h2>
//         <p className="text-gray-700">
//           We understand that plans can change. Please review our cancellation
//           terms below:
//         </p>
//       </div>

//       <div className="space-y-4 text-gray-700">
//         {policies.map((policy, index) => (
//           <div key={index}>
//             <p className="font-medium">
//               {policy.icon} {policy.condition}
//             </p>
//             <p className="ml-5">{policy.detail}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default CancellationPolicy;

import React from "react";

const CancellationPolicy = () => {
  const policies = [
    {
      number: "01",
      condition: "15 days or more before your event",
      detail:
        "Cancel at least 15 days before the event to receive a 50% refund of your booking amount.",
    },
    {
      number: "02",
      condition: "Less than 7 days before your event",
      detail:
        "Bookings cancelled fewer than 7 days before the event are not eligible for a refund.",
    },
    {
      number: "03",
      condition: "Need to transfer your booking?",
      detail:
        "You may transfer your booking to a friend or family member. Please let us know at least 48 hours before the event.",
    },
    {
      number: "04",
      condition: "If we need to cancel or reschedule",
      detail:
        "If weather, safety concerns, government restrictions, public protests, or another unforeseen event means we cannot host your booking, we will offer a full refund or the option to reschedule.",
    },
  ];

  return (
    <main className="mx-auto max-w-5xl rounded-3xl bg-gradient-to-br from-sky-50 via-blue-50 to-slate-50 px-4 py-8 text-slate-800 sm:px-6 sm:py-12 lg:px-8">
      <header className="mb-8 rounded-2xl bg-gradient-to-r from-blue-950 to-blue-800 px-6 py-8 text-white shadow-md sm:px-9 sm:py-10">
        <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-amber-200">
          Plans can change
        </p>
        <h1 className="text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
          Cancellation & Booking Changes
        </h1>
        <p className="mt-3 max-w-2xl text-sm leading-6 text-blue-50 sm:text-base">
          We understand that plans sometimes shift. Here is what to expect if
          you need to change or cancel your booking.
        </p>
      </header>

      <section className="grid gap-4 sm:grid-cols-2" aria-label="Cancellation terms">
        {policies.map((policy) => (
          <article
            key={policy.number}
            className="rounded-2xl border border-amber-200 bg-amber-50/90 p-5 shadow-sm sm:p-6"
          >
            <div className="mb-3 flex items-center gap-3">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-blue-950">
                {policy.number}
              </span>
              <h2 className="text-base font-semibold leading-6 text-stone-900 sm:text-lg">
                {policy.condition}
              </h2>
            </div>
            <p className="text-sm leading-7 text-stone-700 sm:text-base">
              {policy.detail}
            </p>
          </article>
        ))}
      </section>

      <p className="mt-4 rounded-xl border border-orange-200 bg-orange-100/80 px-5 py-4 text-sm leading-6 text-stone-800 sm:text-base">
        Cancellations made 7–14 days before the event are not covered by the
        timeframes listed above. Please contact our team to confirm the terms
        that apply to your booking. For any other questions, we are happy to
        help.
      </p>
    </main>
  );
};

export default CancellationPolicy;
